import React, { ReactElement } from "react";
import { gql, useMutation } from "@apollo/client";
import { normalizeErrors } from "../../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../../types/NormalizedErrorMap";
import { GetVirtualAccountMutationMutation } from "../../../../schemaTypes";

export const getVirtualAccountMutation = gql`
  mutation GetVirtualAccountMutation {
    getVirtualAccount {
      errors {
        path
        message
      }
      message
      data {
        static_account
        bank_name
        bank_code
        currency
        is_default
      }
    }
  }
`;

interface VirtualAccountData {
  static_account?: string | null;
  bank_name?: string | null;
  bank_code?: string | null;
  currency?: string | null;
  is_default?: boolean | null;
}

interface Props {
  children: (
    data: {
      submitGetVirtualAccount: () => Promise<NormalizedErrorMap | null>;
      loading: boolean;
      error: any;
      message: string | null;
      virtualAccountData: VirtualAccountData | null;
    }
  ) => ReactElement | null;
}

export const GetVirtualAccountController: React.FC<Props> = ({ children }) => {
  const [mutate, { loading, error, data }] = useMutation<GetVirtualAccountMutationMutation>(
    getVirtualAccountMutation
  );

  const submitGetVirtualAccount = async () => {
    const { data: { getVirtualAccount } = {} }: any = await mutate();

    if (getVirtualAccount?.errors) {
      return normalizeErrors(getVirtualAccount.errors);
    }

    return null;
  };

  const message = data?.getVirtualAccount?.message || null;

  const virtualAccountData: VirtualAccountData | null  = data?.getVirtualAccount.data || null;

  return children({
    submitGetVirtualAccount,
    loading,
    error,
    message,
    virtualAccountData,
  });
};